var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlineEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.5H3.16667C2.72464 2.5 2.30072 2.67559 1.98816 2.98816C1.67559 3.30072 1.5 3.72464 1.5 4.16667V15.8333C1.5 16.2754 1.67559 16.6993 1.98816 17.0118C2.30072 17.3244 2.72464 17.5 3.16667 17.5H14.8333C15.2754 17.5 15.6993 17.3244 16.0118 17.0118C16.3244 16.6993 16.5 16.2754 16.5 15.8333V10",
    stroke: "#25A07B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3125 2.18744C14.644 1.85592 15.0936 1.66968 15.5625 1.66968C16.0313 1.66968 16.4809 1.85592 16.8125 2.18744C17.144 2.51897 17.3302 2.9686 17.3302 3.43744C17.3302 3.90629 17.144 4.35592 16.8125 4.68744L8.99996 12.4999L5.66663 13.3333L6.49996 9.99994L14.3125 2.18744Z",
    stroke: "#25A07B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineEdit);
export default __webpack_public_path__ + "static/media/outline-edit.a54a43ae1c9625393ed2b6c3b9a25189.svg";
export { ForwardRef as ReactComponent };